import { render } from "./AccountingLayout.vue?vue&type=template&id=4cbf8b00&scoped=true"
import script from "./AccountingLayout.vue?vue&type=script&lang=js"
export * from "./AccountingLayout.vue?vue&type=script&lang=js"

import "./AccountingLayout.vue?vue&type=style&index=0&id=4cbf8b00&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbf8b00"]])

export default __exports__